<template>
    <v-container>
        <h1>Roster</h1>
        <!-- <p>{{ this.terms }}</p> -->
        <div class="typography" v-if="this.$store.state.status === 'fetch_success'">
            <h3>{{ this.course_title }} ({{ this.$route.params.id }})</h3>
        <div class="table_wrapper">
            <div class="table_wrapper_inner">
                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>ID</th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="student in this.student_array" v-bind:key="student.student_id">
                            <td>{{ student.first_name }} {{ student.last_name }}</td>
                            <td>{{ student.student_id }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        </div>
        <div v-else>
            <v-skeleton-loader
            class="mx-auto"
            type="table-body, table-row-divider@6"
            ></v-skeleton-loader>
        </div>
        
    </v-container>
</template>

<script>
export default {

    data: () => ({
        student_array: null,
        course_title: ''
    }),

    mounted() {
        this.$store.dispatch('fetchInstructorRoster')
        .then((resp) => {
                window.console.log("DEETS: "+resp)
                for (var i = 0; i < this.course_rosters.length; i++) {
                    window.console.log(this.course_rosters[i].course_id + ' ' +this.$route.params.id.split('-')[1])
                    if (this.course_rosters[i].course_id === this.$route.params.id.split('-')[1] && this.course_rosters[i].term_code === this.$route.params.id.split('-')[0].replace('*', '/')) {
                        this.student_array = this.course_rosters[i].students
                        window.console.log(this.course_rosters[i].title)
                        this.course_title = this.course_rosters[i].title
                        window.console.log("String " + JSON.stringify(this.student_array))
                    }
                }
        })

        
    },

    computed: {
        course_rosters: function() {
            return this.$store.getters.course_rosters
        }
    }
}
</script>
